@if (fetchingDataFromServer === true && !offlineMode) {
  <div class="alert alert-primary mb-3">
    <div class="fw-bold">
      Fetching Data from Server
      <div class="spinner-grow float-end" role="status"></div>
    </div>
  </div>
}

@if (patrolRouteStatusKey === 2 && isAdmin) {
  <div class="text-end my-2">
    <!-- allow admin to send missed cp scan report on demand-->
    <button
      class="btn btn-success btn-sm me-lg-2"
      (click)="generateMissedReport()"
    >
      Get Missed Scans Report
    </button>
  </div>
}

@if (checkpointPatrolDetailData && !updateTask) {
  <div>
    <div
      id="patrolDetail"
      [ngStyle]="{
        'padding-bottom': bottomSectionFixedHeight,
      }"
    >
      <div class="d-flex flex-column flex-lg-row-reverse">
        <div
          class="col col-lg-8 d-flex flex-wrap column-gap-5 row-gap-3 p-3 p-lg-4 border-lg border-lg-3 rounded"
        >
          <dl id="patrolName">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <dt>Patrol Name</dt>
                <dd
                  [ngClass]="
                    isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                      ? 'link-edit'
                      : ''
                  "
                  (click)="
                    isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                      ? openTemplate(updatePatrolNameTemplate, 'name')
                      : ''
                  "
                >
                  {{ checkpointPatrolDetailData?.name }}
                </dd>
              </div>
            </div>
          </dl>
          <div>
            <dl>
              <!-- Date/Duration Section -->
              <dt>Start Date</dt>
              <dd>
                {{
                  checkpointPatrolDetailData?.schedule_event_date
                    ? (checkpointPatrolDetailData?.schedule_event_date
                      | customDate: "d MMM y")
                    : (checkpointPatrolDetailData?.roster_scheduler?.start_day
                      | customDate: "d MMM y")
                }}
              </dd>
            </dl>
          </div>
          <div>
            <dl>
              <div class="d-flex align-items-center">
                <div>
                  <dt>Shift [Start - End]</dt>
                  <dd
                    [ngClass]="
                      canScheduleBeUpdated && (isAdmin || isDispatchUser)
                        ? 'link-edit'
                        : ''
                    "
                    (click)="
                      canScheduleBeUpdated && (isAdmin || isDispatchUser)
                        ? openScheduleTemplate()
                        : ''
                    "
                  >
                    {{
                      checkpointPatrolDetailData?.roster_scheduler?.start_time
                    }}
                    -
                    {{ checkpointPatrolDetailData?.roster_scheduler?.end_time }}
                    <div class="small">({{ scheduleDuration }} Hours)</div>
                  </dd>
                </div>
              </div>
            </dl>
          </div>
          <div>
            @if (
              showWelfareItem &&
              (isAdmin ||
                isDispatchUser ||
                checkpointPatrolDetailData?.interval_check > 0)
            ) {
              <dl>
                <div>
                  <dt>Welfare Checks</dt>
                  <dd
                    [ngClass]="
                      intervalData?.length && (isAdmin || isDispatchUser)
                        ? 'link-edit'
                        : ''
                    "
                    (click)="
                      intervalData?.length && (isAdmin || isDispatchUser)
                        ? openIntervalCheckTemplate(welfareIntervalTemplate)
                        : ''
                    "
                  >
                    @if (checkpointPatrolDetailData?.interval_check == 0) {
                      Disabled
                    } @else {
                      <span class="text-primary fw-medium">
                        <i class="fa-solid fa-person-circle-check"></i>
                        {{ checkpointPatrolDetailData?.interval_check }}
                        mins</span
                      >
                    }
                  </dd>
                </div>
              </dl>
            }
          </div>
          @if (isAdmin || isDispatchUser) {
            <dl id="patrolAssignedGuards">
              <dt>
                {{
                  checkpointPatrolDetailData?.subscriber_users?.length > 1
                    ? "Assigned Guards"
                    : "Assigned Guard"
                }}
              </dt>
              <dd
                class="d-flex align-items-center"
                [class.link-edit]="
                  isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                "
                (click)="
                  isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                    ? openTemplate(singleAssigneeSelectionTemplate, 'assignee')
                    : ''
                "
              >
                @if (checkpointPatrolDetailData?.subscriber_users?.length) {
                  @if (
                    checkpointPatrolDetailData?.subscriber_users[0]
                      ?.acceptance_status === 2
                  ) {
                    <span
                      title="Pending Acceptance"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      class="text-warning fw-bold fs-5 me-1"
                      ><i class="fa-solid fa-circle-question"></i
                    ></span>
                  }
                  @if (
                    checkpointPatrolDetailData?.subscriber_users[0]
                      ?.acceptance_status === 1
                  ) {
                    <span
                      title="Shift Accepted"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      class="text-success fw-bold fs-5 me-1"
                      ><i class="fa-solid fa-circle-check"></i
                    ></span>
                  }
                  <span
                    [gtappPopover]="userDetailPopoverTemplate"
                    [popoverData]="{
                      userId:
                        checkpointPatrolDetailData?.subscriber_users[0]?.id,
                    }"
                  >
                    {{
                      checkpointPatrolDetailData?.subscriber_users[0]?.full_name
                    }}
                  </span>
                } @else {
                  <div class="text-danger">Not Assigned</div>
                }
              </dd>
            </dl>
          }
          @if (
            isAdmin ||
            isDispatchUser ||
            checkpointPatrolDetailData?.patrol_brief
          ) {
            <dl>
              <!-- Patrol Information Section -->
              <dt>Patrol Information</dt>
              <dd
                class="gt-multi-line"
                [class.link-edit]="
                  isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                "
                (click)="
                  isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                    ? openPatrolBriefInformationTemplate(requestRef)
                    : ''
                "
              >
                {{
                  checkpointPatrolDetailData?.patrol_brief
                    ? checkpointPatrolDetailData?.patrol_brief
                    : "N/A"
                }}
              </dd>
            </dl>
          }
          @if (
            isAdmin ||
            isDispatchUser ||
            checkpointPatrolDetailData?.patrol_brief_files?.length
          ) {
            <dl>
              <!-- File Attachments Section -->
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <dt>
                    {{
                      isAdmin || isDispatchUser
                        ? "Attachments [" +
                          checkpointPatrolDetailData?.patrol_brief_files
                            ?.length +
                          " / 3 Max]"
                        : "Attachments"
                    }}
                  </dt>
                </div>
                @if (
                  (isAdmin || isDispatchUser) &&
                  checkpointPatrolDetailData?.patrol_brief_files?.length < 3 &&
                  isCurrentORFutureSchedule
                ) {
                  <div>
                    <label for="file-upload">
                      <dt class="me-1">
                        <i
                          class="fa-solid fa-plus-circle md-font-size text-secondary"
                        ></i>
                      </dt>
                    </label>
                    @if (
                      (isAdmin || isDispatchUser) &&
                      checkpointPatrolDetailData?.patrol_brief_files?.length < 3
                    ) {
                      <input
                        id="file-upload"
                        type="file"
                        accept="application/pdf, image/*"
                        (change)="handleFileInput($event)"
                      />
                    }
                  </div>
                }
              </div>
              <dd class="d-flex gap-2 flex-wrap">
                @for (
                  file of checkpointPatrolDetailData?.patrol_brief_files;
                  track file;
                  let i = $index
                ) {
                  <div>
                    <div
                      class="d-flex border p-2 rounded text-primary fw-semibold gap-4"
                      role="button"
                    >
                      <div class="flex-grow-1" (click)="onOpenFile(file)">
                        <span class="badge bg-primary me-2">{{
                          file?.extension
                        }}</span>
                        File {{ i + 1 }}
                      </div>
                      @if (isAdmin || isDispatchUser) {
                        <span
                          class="d-flex align-items-center me-2"
                          (click)="deleteFile(file)"
                        >
                          <i
                            class="fs-5 fa-solid fa-circle-minus text-danger"
                          ></i>
                        </span>
                      }
                    </div>
                  </div>
                }
              </dd>
            </dl>
          }
        </div>
        <div class="col-lg-4 p-3">
          <dl id="patrolCheckpoints">
            <dt
              class="mb-2"
              [class.link-edit]="
                isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
              "
              [class.link-view]="
                (!isCurrentORFutureSchedule || !(isAdmin || isDispatchUser)) &&
                checkpointPatrolDetailData?.check_points?.length > 5
              "
              [class.opacity-100]="
                (isCurrentORFutureSchedule && (isAdmin || isDispatchUser)) ||
                checkpointPatrolDetailData?.check_points?.length > 5
              "
              (click)="
                isCurrentORFutureSchedule && (isAdmin || isDispatchUser)
                  ? openTemplate(updateCheckpointTemplate, 'checkpoint')
                  : checkpointPatrolDetailData?.check_points?.length > 5
                    ? openTemplate(checkpointListTemplate, 'showAllCheckpoints')
                    : null
              "
            >
              Checkpoints [{{ scannedCheckpointCount }} /
              {{ checkpointPatrolDetailData?.check_points?.length }}]
              @if ((isAdmin || isDispatchUser) && isCurrentORFutureSchedule) {
                <span class="border rounded ms-2 px-2 bg-primary text-white"
                  >Add / Remove</span
                >
              }
            </dt>
            <dd>
              @for (
                item of checkpointPatrolDetailData?.check_points?.slice(0, 5);
                track item;
                let i = $index
              ) {
                <div
                  class="d-flex mb-2 p-2 shadow rounded border"
                  [ngClass]="
                    item?.is_deleted || item?.site_is_deleted
                      ? 'opacity-50'
                      : ''
                  "
                >
                  <ng-template
                    *ngTemplateOutlet="
                      selectedCheckpointDetail;
                      context: { value: item }
                    "
                  ></ng-template>
                </div>
              }
            </dd>
          </dl>
        </div>
      </div>
      @if (patrolLogUpdates?.length && !largeView) {
        <div class="text-end my-3">
          <button
            class="btn btn-sm btn-dark"
            (click)="changeSortOrder = !changeSortOrder"
            [disabled]="patrolLogUpdates?.length < 2"
          >
            Sort
            <span>
              <i class="fa-solid fa-sort"></i>
            </span>
          </button>
        </div>
        @for (
          msg of changeSortOrder
            ? mobileUpdatesLog
            : mobileUpdatesLog?.slice()?.reverse();
          track msg;
          let i = $index
        ) {
          <div class="p-2 shadow border rounded mb-2">
            <dl [ngClass]="msg?.is_deleted ? 'opacity-50' : ''">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1 small-font">
                  <dt>
                    <!--update details section-->
                    @if (msg?.file) {
                      <span>
                        {{
                          [".mp4", ".mov", ".webm", ".mkv"].includes(
                            msg?.file_extension
                          )
                            ? "Video"
                            : "Photo"
                        }}
                        {{
                          msg?.event_action === 19
                            ? "[Device Library]"
                            : "[Camera]"
                        }}
                        |
                      </span>
                    }
                    {{
                      msg?.updated_datetime ?? msg?.updated_at
                        | customDate: "d MMM y HH:mm"
                    }}
                    |
                    {{
                      subscriberUserId == msg?.subs_user_id
                        ? "You"
                        : msg?.user_name
                    }}
                    @if (
                      msg?.history_changes?.length &&
                      (subscriberUserId == msg?.subs_user_id ||
                        isAdmin ||
                        isDispatchUser)
                    ) {
                      <span>
                        | Edited [{{
                          (
                            msg?.history_changes
                            | misc: "lastCommentEditedDateTime"
                          )?.updated_at | customDate: "d MMM y HH:mm"
                        }}]</span
                      >
                    }
                  </dt>
                </div>
                @if (msg?.id && !msg?.cachedData) {
                  @if (
                    (subscriberUserId == msg?.subs_user_id ||
                      isAdmin ||
                      isDispatchUser) &&
                    !offlineMode &&
                    [1, 2, 7].includes(msg?.event_action)
                  ) {
                    <div
                      (click)="
                        deleteRestoreUserUpdate({
                          event: msg,
                          type: msg?.is_deleted ? 'restore' : 'delete',
                        })
                      "
                      class="ms-1"
                    >
                      @if (msg?.is_deleted) {
                        <span>
                          <i
                            class="fa-regular fa-square-plus md-font-size text-secondary"
                          ></i>
                        </span>
                      } @else {
                        <span>
                          <i
                            class="fa-regular fa-square-minus md-font-size text-secondary"
                          ></i>
                        </span>
                      }
                    </div>
                  }
                }
                @if (!msg?.id && msg?.index_db_id) {
                  <!--item not in server but in indeced db in that case provide option to delete it from index db-->
                  <span (click)="deleteItemFromNativeDb(msg)">
                    <i
                      class="fa-solid fa-trash md-font-size text-secondary"
                    ></i>
                  </span>
                }
                @if (msg?.cachedData) {
                  <div class="ms-1">
                    @if (errorItemsIdsInQueue.has(msg?.index_db_id)) {
                      <span
                        (click)="retrySendingUpdate()"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="An error occured while saving data. Retrying."
                      >
                        <i
                          class="fa-solid fa-triangle-exclamation text-danger md-font-size"
                        ></i>
                      </span>
                    } @else {
                      <span
                        (click)="retrySendingUpdate()"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="This update has not yet been uploaded to the server."
                      >
                        <i
                          class="fa-solid fa-triangle-exclamation text-warning md-font-size"
                        ></i>
                      </span>
                    }
                  </div>
                }
              </div>
              <dd class="mb-4">
                <!-- comment / photo -->
                @if (msg?.event_action === 9) {
                  <div>CHECKED IN</div>
                }
                <div class="pb-3">
                  <span
                    class="gt-multi-line"
                    [class.link-edit]="
                      (subscriberUserId == msg?.subs_user_id ||
                        isAdmin ||
                        isDispatchUser) &&
                      !offlineMode &&
                      [1, 2, 7].includes(msg?.event_action) &&
                      msg?.id &&
                      !msg?.cachedData &&
                      !msg?.is_deleted
                    "
                    (click)="
                      (subscriberUserId == msg?.subs_user_id ||
                        isAdmin ||
                        isDispatchUser) &&
                      !offlineMode &&
                      [1, 2, 7].includes(msg?.event_action) &&
                      msg?.id &&
                      !msg?.cachedData &&
                      !msg?.is_deleted
                        ? editComment(msg, commentRef)
                        : null
                    "
                  >
                    @if (
                      (msg?.detail === "null" ||
                        msg?.detail === "undefined" ||
                        !msg?.detail) &&
                      (subscriberUserId == msg?.subs_user_id ||
                        isAdmin ||
                        isDispatchUser) &&
                      !offlineMode &&
                      [1, 2, 7].includes(msg?.event_action) &&
                      msg?.id &&
                      !msg?.cachedData &&
                      !msg?.is_deleted
                    ) {
                      <div
                        class="rounded border shadow p-1 px-5 text-center hover"
                        role="button"
                      >
                        <i class="fa-solid fa-comment-dots text-body fa-2x"></i>
                      </div>
                    } @else {
                      {{ msg?.detail }}
                    }
                  </span>
                  @if (msg?.event_action === 0) {
                    <span class="small-font">[Checkpoint Scan]</span>
                  }
                  @if (msg?.event_action === 6) {
                    <span class="small-font">[QR Scan]</span>
                  }
                  @if (msg?.event_action === 12) {
                    <span class="small-font">[NFC Scan]</span>
                  }
                </div>
                @if (msg?.file) {
                  <ng-template
                    *ngTemplateOutlet="
                      filePreviewTemplate;
                      context: {
                        value: msg,
                        inBrowser: !msg?.id && !isNativeApp,
                      }
                    "
                  ></ng-template>
                }
                <div class="small-font text-secondary text-end">
                  @if (
                    (msg | misc: "getEventUpadteFilters" : "patrol")?.delete
                      ?.updated_at
                  ) {
                    <div>
                      Deleted:
                      {{
                        (msg | misc: "getEventUpadteFilters" : "patrol")?.delete
                          ?.updated_at | customDate: "d MMM y HH:mm"
                      }}
                      |
                      {{
                        (msg | misc: "getEventUpadteFilters" : "patrol")?.delete
                          ?.user_name
                      }}
                    </div>
                  }
                  @if (
                    (msg | misc: "getEventUpadteFilters" : "patrol")?.restore
                      ?.updated_at && !msg?.is_deleted
                  ) {
                    Restored:
                    {{
                      (msg | misc: "getEventUpadteFilters" : "patrol")?.restore
                        ?.updated_at | customDate: "d MMM y HH:mm"
                    }}
                    |
                    {{
                      (msg | misc: "getEventUpadteFilters" : "patrol")?.restore
                        ?.user_name
                    }}
                  }
                </div>
              </dd>
            </dl>
          </div>
        }
      }
      @if (largeView) {
        <div class="row row-cols-1 row-cols-md-2 col-lg-6">
          @if (patrolRouteStatus?.[patrolRouteStatusKey]?.value) {
            <div>
              <div
                id="patrolStatus"
                class="btn-lg rounded-0 w-100 d-flex align-items-center justify-content-center"
                [ngStyle]="patrolRouteStatus?.[patrolRouteStatusKey]?.style"
              >
                {{ patrolRouteStatus?.[patrolRouteStatusKey]?.value }}
              </div>
            </div>
          }
          @if (isCurrentORFutureSchedule) {
            <div class="col">
              <button
                id="addComment"
                class="btn btn-primary btn-lg rounded-0 w-100"
                (click)="updateTask = 'addSiteComment'"
              >
                + Add Comment
              </button>
            </div>
          }
          @if (canDeclineJob) {
            <div class="col">
              <button
                class="btn btn-lg w-100 btn-danger"
                (click)="openJobDeclineTemplate(jobDeclineTemplateRef)"
              >
                Decline Shift
              </button>
            </div>
          }
        </div>
      }
    </div>
    @if (!largeView) {
      <div class="section">
        <div
          class="section bottom-section box-shadow-top"
          id="bottom-section-fixed"
        >
          <!--online buttons (check conditions are different)-->
          <div class="p-2" id="patrolUpdate">
            @if (
              nfcCheckpointsInPatrol &&
              !nfcReaderAvailable &&
              isCurrentORFutureSchedule
            ) {
              <div
                class="text-danger small text-center border p-1 border-danger mb-1 border-2 rounded"
              >
                NFC Checkpoints Cannot Be Scanned With This Device/Browser
              </div>
            }
            <div [ngStyle]="patrolRouteStatus?.[patrolRouteStatusKey]?.style">
              {{ patrolRouteStatus?.[patrolRouteStatusKey]?.value }}
            </div>
            @if (
              canDeclineJob && isCurrentORFutureSchedule && !requiresAcceptance
            ) {
              <div class="col">
                <button
                  class="btn btn-lg w-100 my-2 btn-danger"
                  (click)="openJobDeclineTemplate(jobDeclineTemplateRef)"
                >
                  Decline
                </button>
              </div>
            }

            @if (requiresAcceptance) {
              <div class="row row-cols-2 my-2">
                <div class="col">
                  <button
                    class="btn btn-lg w-100 btn-success"
                    (click)="updatePatrolRoute('acceptJob')"
                  >
                    Accept
                  </button>
                </div>
                <div class="col">
                  <button
                    class="btn btn-lg w-100 btn-danger"
                    (click)="openJobDeclineTemplate(jobDeclineTemplateRef)"
                  >
                    Decline
                  </button>
                </div>
              </div>
            } @else if (shiftClockInOutParms.requiresClockInOut) {
              @if (!shiftClockInOutParms.hasUserClockedOut) {
                @if (shiftClockInOutParms.hasUserClockedIn) {
                  <div class="col mb-2">
                    <button
                      class="btn btn-lg w-100 btn-warning"
                      (click)="onClockInOutUser()"
                    >
                      Clock Out
                    </button>
                  </div>
                } @else {
                  <div class="col mb-2">
                    <button
                      class="btn btn-lg w-100 btn-primary"
                      [disabled]="!scheduleCheck"
                      (click)="onClockInOutUser()"
                    >
                      Clock In
                    </button>
                  </div>
                }
              }
            }
            @if (
              (shiftClockInOutParms.hasUserClockedIn &&
                !shiftClockInOutParms.hasUserClockedOut) ||
              !shiftClockInOutParms.requiresClockInOut
            ) {
              @if (isCurrentORFutureSchedule && scheduleCheck) {
                <div class="d-flex column-gap-1" id="patrolUpdateHomeBtns">
                  <div
                    class="d-flex flex-column align-items-center justify-content-center w-100 bg-body-secondary text-body-emphasis btm-btn-height rounded border border-secondary"
                    (click)="updateTask = 'addSiteComment'"
                  >
                    <i class="fa-regular fa-message fs-5"></i>
                    <div>Add Comment</div>
                  </div>
                  <div
                    id="scanCheckpointTemplateId"
                    class="d-flex flex-column align-items-center justify-content-center w-100 bg-primary-subtle text-primary-emphasis btm-btn-height text-center rounded border border-primary"
                    (click)="openScanCPTemplate()"
                  >
                    <div>Scan Checkpoint</div>
                  </div>
                  <div
                    class="d-flex flex-column align-items-center justify-content-center w-100 bg-body-secondary text-body-emphasis btm-btn-height rounded border border-secondary"
                    (click)="updateTask = 'addSitePhoto'"
                  >
                    <i class="fa-solid fa-camera fs-5"></i>
                    <div>Upload Photo</div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </div>
    }
    @if (largeView) {
      @if (
        isAdmin || isDispatchUser
          ? patrolUpdateLog?.length
          : patrolLogUpdates?.length
      ) {
        <div class="row row-cols-3 border border-3">
          <div class="col-4">
            <gtapp-gt-table
              id="patrolHistory"
              [desktopTableUIData]="
                isAdmin || isDispatchUser ? patrolUpdateLog : patrolLogUpdates
              "
              [desktopTableDetails]="patrolLogTableDetail"
              [otherParams]="otherParams"
              [tableStyle]="{
                'overflow': 'auto',
                'max-height': '400px',
              }"
              (rowClick)="onTableRowClick($event)"
            >
            </gtapp-gt-table>
          </div>
          <div class="col-8">
            <!-- SELECTED DETAILS -->
            @if (selectedEvent) {
              <gtapp-updated-event-detail
                [selectedEvent]="selectedEvent"
                [userEventDetailsTableView]="patrolLogTableDetail"
                selectedEventFrom="patrol"
                [extraCheck]="!offlineMode"
                (editUserComment)="editComment($event, commentRef)"
                (deleteRestoreUserUpdate)="deleteRestoreUserUpdate($event)"
              ></gtapp-updated-event-detail>
            }
          </div>
        </div>
      }
    }
  </div>
}

@if (
  ["scanCheckPoint", "addSiteComment", "addSitePhoto"].includes(updateTask)
) {
  <gtapp-update-events
    [detailType]="updateTask"
    [details]="{
      filterPatrolData: filterPatrolData,
      patrolRouteId: checkpointPatrolDetailData?.id,
    }"
    (emitData)="closeDetailedHome()"
  >
  </gtapp-update-events>
}

<ng-template
  #updateCheckpointTemplate
  let-data
  let-updateCheckpointTemplate="dialogRef"
>
  <div class="card dialog-box cp-dialogue-width">
    <div class="card-header">
      Select Checkpoints
      <span class="float-end" (click)="updateCheckpointTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    @if (!largeView) {
      <div class="row row-cols-2 mb-3">
        <div class="col">
          <button
            class="btn btn-lg btn-dark w-100"
            (click)="updateCheckpointTemplate.close()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            type="submit"
            class="btn btn-lg btn-primary w-100"
            [disabled]="checkpointUpdateDisabling() || updateBtnPressed"
            (click)="updatePatrolRoute('checkpoint')"
          >
            Submit
          </button>
        </div>
      </div>
    }
    <div>
      @if (!largeView) {
        <!-- Tabs Navigation for mobile view-->
        <ul class="nav nav-tabs mb-2" id="checkpointsTab" role="tablist">
          <li class="nav-item" role="presentation">
            <a
              class="nav-link active"
              id="all-checkpoints-tab"
              data-bs-toggle="tab"
              href="#all-checkpoints"
              role="tab"
              aria-controls="all-checkpoints"
              aria-selected="true"
              >Checkpoints</a
            >
          </li>
          <li class="nav-item" role="presentation">
            <a
              class="nav-link"
              id="selected-checkpoints-tab"
              data-bs-toggle="tab"
              href="#selected-checkpoints"
              role="tab"
              aria-controls="selected-checkpoints"
              aria-selected="false"
              >Added
              <span class="ms-1">[{{ selectedCheckpoints?.length }}]</span>
            </a>
          </li>
        </ul>
        <!-- Tabs Content -->
        <div class="tab-content" id="checkpointsTabContent">
          <!-- All Checkpoints Tab -->
          <div
            class="tab-pane fade show active"
            id="all-checkpoints"
            role="tabpanel"
            aria-labelledby="all-checkpoints-tab"
          >
            <ng-template
              *ngTemplateOutlet="
                checkPointSearchSelectTemplate;
                context: { value: { search: true } }
              "
            ></ng-template>
          </div>
          <!-- Selected Checkpoints Tab -->
          <div
            class="tab-pane fade"
            id="selected-checkpoints"
            role="tabpanel"
            aria-labelledby="selected-checkpoints-tab"
          >
            <ng-template
              *ngTemplateOutlet="checkPointSearchSelectTemplate; context: {}"
            ></ng-template>
          </div>
        </div>
      }
      @if (largeView) {
        <div class="row row-cols-2 mb-1">
          <div class="col">
            <ng-template
              *ngTemplateOutlet="
                checkPointSearchSelectTemplate;
                context: { value: { search: true } }
              "
            ></ng-template>
          </div>
          <div class="col">
            <ng-template
              *ngTemplateOutlet="checkPointSearchSelectTemplate; context: {}"
            ></ng-template>
            <div class="border rounded fs-5 p-2 text-center">
              <span class="text-secondary"> Checkpoints:</span>
              <span class="fw-semibold">
                {{ selectedCheckpoints?.length }}</span
              >
            </div>
          </div>
        </div>
      }
    </div>

    <div class="row row-cols-2">
      <div class="col">
        <button
          class="btn btn-lg btn-secondary w-100"
          (click)="updateCheckpointTemplate.close()"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          type="submit"
          class="btn btn-lg btn-primary w-100"
          [disabled]="checkpointUpdateDisabling() || updateBtnPressed"
          (click)="updatePatrolRoute('checkpoint')"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template
  #singleAssigneeSelectionTemplate
  let-data
  let-singleAssigneeSelectionTemplate="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      <span class="float-end" (click)="singleAssigneeSelectionTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="p-3">
        @if (selectedAssignee?.id) {
          <dl>
            <dt>Assigned To</dt>
            <dd
              class="link-edit"
              (click)="
                selectedAssignee = {};
                clearAndFocusTextBox('assigneLookupFieldId')
              "
            >
              <span> {{ selectedAssignee?.full_name }}</span>
            </dd>
          </dl>
        } @else {
          <gtapp-auto-complete
            [data]="assigneeList"
            placeHolder="Search/Select Assignee"
            searchKeyword="full_name"
            inputId="assigneLookupFieldId"
            [initialValue]="selectedAssignee?.full_name"
            [itemTemplate]="assigneeLookupTemplate"
            (inputChanged)="onAssigneeSearch($event)"
            (selected)="selectedAssignee = $event"
            [enableCloseOption]="true"
          >
          </gtapp-auto-complete>

          <ng-template #assigneeLookupTemplate let-item>
            <div class="d-flex gap-2 flex-wrap">
              <span>
                {{ item?.full_name }}
              </span>
              @if (item?.access_status === 2) {
                <div
                  class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                >
                  Casual
                </div>
              }
            </div>

            @if (item?.subcontractors?.length) {
              <div class="small text-secondary">
                🟧Subcontractor:
                <span class="subcontractor-name">{{
                  item?.subcontractors
                }}</span>
              </div>
            }
          </ng-template>
        }
      </div>

      <div class="row row-cols-2 mt-4">
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-dark"
            (click)="singleAssigneeSelectionTemplate.close()"
          >
            Cancel
          </button>
        </div>

        <div class="col">
          <button
            class="btn btn-primary btn-lg w-100"
            [disabled]="
              selectedAssignee?.id ===
                checkpointPatrolDetailData?.subscriber_users?.[0]?.id ||
              updateBtnPressed
            "
            (click)="updatePatrolRoute('assignee')"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #updatePatrolNameTemplate let-updatePatrolNameTemplate="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Update Patrol Name

      <span class="float-end" (click)="updatePatrolNameTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="form-floating mt-3">
      <input
        class="form-control"
        id="mobassigneeField"
        [(ngModel)]="newPatrolName"
        type="text"
        autocomplete="off"
        placeholder="Patrol Route Name"
      />
      <label>Patrol Route Name</label>
    </div>
    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="updatePatrolNameTemplate.close()"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="newPatrolName === checkpointPatrolDetailData?.name"
          (click)="updatePatrolRoute('name')"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #welfareIntervalTemplate let-welfareIntervalTemplate="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Welfare Check Interval
      <span class="float-end" (click)="welfareIntervalTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="form-floating">
      <select
        class="form-select"
        id="welfareChecks"
        [(ngModel)]="selectedInterval"
      >
        @for (interval of intervalData; track interval) {
          <option [value]="interval.value">
            {{ interval.name }}
          </option>
        }
      </select>
      <label for="">Welfare Check Interval</label>
    </div>

    @if (selectedInterval > 0) {
      <div class="alert">
        <div class="mb-2">
          Guards will be reminded to submit a welfare check
          <span class="fw-bold">
            {{ welfareReminderDict?.[selectedInterval] }} minutes before</span
          >
          the interval set above.
        </div>
        <div>
          Maximum inactivity time allowed before a missed welfare check is
          recorded:
          <span class="fst-italic fw-bold">
            {{ selectedInterval }} minutes.
          </span>
        </div>
      </div>
    }
    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="welfareIntervalTemplate.close()"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="
            selectedInterval == checkpointPatrolDetailData?.interval_check
          "
          (click)="updateInterval(selectedInterval)"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- ADD COMMENT POPOVER / DIALOG -->
<ng-template #commentRef let-commentRef="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      {{ data?.detail ? "Edit Comment" : "Add Comment" }}
      <span class="float-end" (click)="commentRef.close(); newComment = ''">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="form-group input-group">
        <textarea
          class="form-control"
          rows="5"
          wrap="hard"
          maxlength="340"
          placeholder="Enter comment here"
          autofocus
          [(ngModel)]="newComment"
          id="updateCommentBox"
        ></textarea>
        @if (newComment) {
          <span
            class="input-group-text"
            (click)="clearAndFocusTextBox('updateCommentBox')"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="commentRef.close(); newComment = ''"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          @if (data?.id && (data?.file || data?.file_url)) {
            <button
              class="btn btn-lg w-100"
              [disabled]="previousComment === newComment"
              (click)="addComment(data); commentRef.close()"
              [ngClass]="newComment ? 'btn-primary' : 'btn-danger'"
            >
              Update
            </button>
          } @else {
            <button
              class="btn btn-primary btn-lg w-100"
              [disabled]="!newComment || previousComment === newComment"
              (click)="addComment(data); commentRef.close()"
            >
              {{ data?.id ? "Update" : "Add" }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #requestRef let-requestRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Patrol Information
      <span (click)="requestRef.close()" class="float-end"
        ><i class="fa-solid fa-xmark"></i
      ></span>
    </div>

    <!-- Request Detail Section start-->

    <div class="col">
      <textarea
        class="form-control"
        placeholder="Patrol Information"
        cols="20"
        rows="5"
        wrap="hard"
        type="text"
        [(ngModel)]="newInfromation"
      ></textarea>
    </div>

    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button class="btn btn-lg w-100 btn-dark" (click)="requestRef.close()">
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          [disabled]="
            newInfromation === checkpointPatrolDetailData?.patrol_brief
          "
          class="btn btn-lg w-100 btn-primary"
          (click)="updatePatrolRoute('patrol_brief'); requestRef.close()"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #checkpointListTemplate let-checkpointListTemplate="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Checkpoints [{{ scannedCheckpointCount }} /
      {{ checkpointPatrolDetailData?.check_points?.length }}]
      <span (click)="checkpointListTemplate.close()" class="float-end"
        ><i class="fa-solid fa-xmark"></i
      ></span>
    </div>
    <div class="overflow-cps">
      @for (
        item of checkpointPatrolDetailData?.check_points;
        track item;
        let i = $index
      ) {
        <div
          class="d-flex mb-3"
          [ngClass]="
            item?.is_deleted || item?.site_is_deleted ? 'opacity-50' : ''
          "
        >
          <ng-template
            *ngTemplateOutlet="
              selectedCheckpointDetail;
              context: { value: item }
            "
          ></ng-template>
        </div>
      }
    </div>
    @if ((isAdmin || isDispatchUser) && isCurrentORFutureSchedule) {
      <div class="row row-cols-2 mt-4">
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-dark"
            (click)="checkpointListTemplate.close()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-primary"
            (click)="
              openTemplate(updateCheckpointTemplate, 'checkpoint');
              checkpointListTemplate.close()
            "
          >
            Edit & Update
          </button>
        </div>
      </div>
    }
  </div>
</ng-template>
<ng-template #selectedCheckpointDetail let-item="value">
  @if (!item?.isScanned && !item?.is_deleted) {
    <div class="d-flex align-items-center">
      <a
        [href]="
          'https://www.google.com/maps/search/?api=1&query=' +
          item?.latitude +
          ',' +
          item?.longitude
        "
        target="_blank"
        class="text-secondary"
      >
        <span>
          <i class="fa-solid fa-map-location-dot fs-4"></i>
        </span>
      </a>
    </div>
  }

  @if (item?.isScanned) {
    <div class="d-flex align-items-center">
      <span>
        <i class="fa-solid fa-check fs-4 text-success"></i>
      </span>
    </div>
  }

  <div class="flex-grow-1 ms-3 me-2">
    <div class="d-flex align-items-center">
      <div>
        <div class="fw-semibold">{{ item.name }}</div>
        <div class="small-font">
          @if (item?.site_name) {
            {{ item?.site_name }} [{{ item?.company_name }}]
          } @else {
            {{ item?.company_name }}
          }
        </div>
        <div class="small">
          {{ item?.full_address }}
        </div>
      </div>
    </div>
  </div>

  @if (item?.qr_code) {
    <div class="me-3 cp-scanned-icon">
      @if (item?.is_nfc_code) {
        <img
          src="assets/images/NFC_logo.avif"
          alt="NFC Code"
          width="30"
          class="mb-0 bg-white p-1 rounded"
        />
        @if (
          item?.is_nfc_code &&
          item?.qr_code &&
          !nfcReaderAvailable &&
          !largeView
        ) {
          <div class="d-flex justify-content-center">
            <span
              title="NFC Checkpoints Cannot Be Scanned With This Device/Browser"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              class="text-danger fw-bold fs-4"
              ><i class="fa-solid fa-triangle-exclamation"></i
            ></span>
          </div>
        }
      } @else {
        <img
          src="assets/images/qr-code-logo.avif"
          alt="QR Code"
          width="30"
          class="mb-0 bg-white p-1 rounded"
        />
      }
    </div>
  }
</ng-template>

<!-- checkpoint search/selection code to avoid code duplcation -->
<ng-template let-dataItem="value" #checkPointSearchSelectTemplate>
  @if (dataItem?.search) {
    @if (patrolRouteCpTotalCount > 10) {
      @if (cpSiteFilter?.id) {
        <dl>
          <dt>Showing Checkpoints for</dt>
          <dd
            (click)="
              cpSiteFilter = {};
              inputFieldFocused();
              shiftFocus('siteId');
              getPatrolRouteCheckpoints()
            "
            class="link-edit"
          >
            {{ cpSiteFilter?.company_name }}
            @if (cpSiteFilter?.company?.company_name) {
              <span> [{{ cpSiteFilter?.company?.company_name }}] </span>
            }
          </dd>
        </dl>
      } @else {
        <gtapp-auto-complete
          [data]="siteListData"
          placeHolder="Filter by Site"
          searchKeyword="company_name"
          [itemTemplate]="siteTemplate"
          (inputChanged)="onSiteSearch($event)"
          (selected)="onSelectSite($event)"
          inputId="siteId"
          [enableCloseOption]="true"
          (inputFocused)="inputFieldFocused()"
        >
        </gtapp-auto-complete>
        <ng-template #siteTemplate let-item>
          <div>
            <div class="fw-medium">
              {{ item?.company_name }} [{{ item?.company?.company_name }}]
            </div>

            <div class="small-font text-secondary">
              {{ item?.address?.full_address }}
            </div>
          </div>
        </ng-template>
      }
      @if (patrolCpFilterValue || patrolRouteCPList?.length) {
        <div class="input-group my-2">
          <div class="form-floating">
            <input
              class="form-control"
              type="text"
              placeholder="Search Filter"
              (input)="searchCheckPoints($event)"
              [(ngModel)]="patrolCpFilterValue"
            />
            <label>Search Filter</label>
          </div>

          @if (patrolCpFilterValue) {
            <span
              class="input-group-text"
              (click)="searchCheckPoints({ target: { value: '' } })"
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
      }
    }
    @if (patrolRouteCPList?.length) {
      @if (!patrolCPCursor && patrolRouteCPList?.length > 1) {
        <div class="text-end my-2">
          <button
            (click)="addAllCheckpoints()"
            class="btn btn-warning btn-sm"
            [disabled]="selectedCheckpoints?.length >= 250"
          >
            Add All
            <span class="fs-6 fw-semibold px-2">{{
              patrolRouteCPList?.length
            }}</span>
          </button>
        </div>
      }
      <div
        class="mb-2"
        [ngClass]="
          patrolRouteCpTotalCount > 10
            ? 'checkpoints-list-with-search'
            : 'checkpoints-list-without-search'
        "
      >
        @for (checkpoint of patrolRouteCPList; track $index) {
          <div class="d-flex align-items-center p-1 p-lg-2 mb-2 gap-2">
            <div
              class="flex-grow-1"
              [class.added-checkpoint]="
                checkpoint?.id === lastAddedCheckpointID
              "
            >
              <div class="fw-semibold">
                {{ checkpoint?.name }}
              </div>

              <div class="small-font fw-semibold">
                @if (checkpoint?.site_name) {
                  {{ checkpoint?.site_name }} [{{
                    checkpoint?.company || checkpoint?.company_name
                  }}]
                } @else {
                  {{ checkpoint?.company || checkpoint?.company_name }}
                }
              </div>

              <div class="small-font text-secondary">
                {{
                  checkpoint?.address?.full_address || checkpoint?.full_address
                }}
              </div>
            </div>
            @if (checkpoint?.qr_code) {
              <div>
                @if (checkpoint?.is_nfc_code) {
                  <img
                    src="assets/images/NFC_logo.avif"
                    alt="NFC Code"
                    width="26"
                    class="mb-0 bg-white p-1 rounded"
                  />
                } @else {
                  <img
                    src="assets/images/qr-code-logo.avif"
                    alt="QR Code"
                    width="26"
                    class="mb-0 bg-white p-1 rounded"
                  />
                }
              </div>
            }

            <div (click)="addSelectedCP(checkpoint)">
              <button
                class="btn btn-primary btn-sm m-0"
                [disabled]="selectedCheckpoints?.length >= 250"
              >
                Add
              </button>
            </div>
          </div>
        }
      </div>
      @if (patrolCPCursor) {
        <div class="text-center my-2">
          <button (click)="onLoadMore()" class="btn btn-secondary btn-md px-4">
            Load More
          </button>
        </div>
      }
    } @else if (cpSiteFilter?.id || patrolCpFilterValue) {
      <div class="alert alert-primary fw-bold">
        No Records Match Your Search Criteria
      </div>
    }
  } @else {
    <div class="checkpoints-list-without-search">
      <div cdkDropList (cdkDropListDropped)="dropNewCheckPoint($event)">
        @for (
          checkpoint of selectedCheckpoints;
          track $index;
          let isLastItem = $last
        ) {
          <div class="d-flex align-items-center p-1 p-lg-2 mb-2 gap-2" cdkDrag>
            @if (selectedCheckpoints?.length > 1) {
              <div cdkDragHandle>
                <i class="fas fa-bars fa-2x"></i>
              </div>
            }

            <div
              class="flex-grow-1"
              [class.added-checkpoint]="
                checkpoint?.id === lastAddedCheckpointID && isLastItem
              "
            >
              <div class="fw-semibold">
                {{ checkpoint?.name }}
              </div>

              <div class="small-font fw-semibold">
                @if (checkpoint?.site_name) {
                  {{ checkpoint?.site_name }} [{{
                    checkpoint?.company || checkpoint?.company_name
                  }}]
                } @else {
                  {{ checkpoint?.company || checkpoint?.company_name }}
                }
              </div>

              <div class="small-font text-secondary">
                {{
                  checkpoint?.address?.full_address || checkpoint?.full_address
                }}
              </div>
            </div>
            @if (checkpoint?.qr_code) {
              <div class="me-2">
                @if (checkpoint?.is_nfc_code) {
                  <img
                    src="assets/images/NFC_logo.avif"
                    alt="NFC Code"
                    width="26"
                    class="mb-0 bg-white p-1 rounded"
                  />
                } @else {
                  <img
                    src="assets/images/qr-code-logo.avif"
                    alt="QR Code"
                    width="26"
                    class="mb-0 bg-white p-1 rounded"
                  />
                }
              </div>
            }
            <div (click)="removeSelectedCP($index)">
              <button class="btn btn-danger btn-sm m-0">Del</button>
            </div>
          </div>
        }
      </div>
      <div id="lastElementAnchor">
        <!--scroll to here/bottom anchor on adding checkpoints-->
      </div>
    </div>
  }
</ng-template>

<!-- JOB DECLINE DIALOG -->
<ng-template
  #jobDeclineTemplateRef
  let-data
  let-jobDeclineTemplateRef="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      Decline Shift
      <span class="float-end" (click)="jobDeclineTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <!-- Request Detail Section start-->
    <div class="form-group input-group mb-3">
      <textarea
        class="form-control"
        placeholder="Decline Reason [160 chars]"
        cols="20"
        rows="4"
        wrap="hard"
        maxlength="160"
        type="text"
        [(ngModel)]="declineReason"
        id="declineReasonField"
      ></textarea>
      @if (declineReason) {
        <span
          class="input-group-text"
          (click)="
            declineReason = ''; clearAndFocusTextBox('declineReasonField')
          "
        >
          <i class="fa-solid fa-xmark"></i>
        </span>
      }
    </div>
    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="jobDeclineTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="!declineReason"
          (click)="declineJob(); jobDeclineTemplateRef.close()"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #filePreviewTemplate let-update="value" let-inBrowser="inBrowser">
  <div class="media-view mb-2" (click)="$event.stopImmediatePropagation()">
    @if ([".mp4", ".mov", ".webm", ".mkv"].includes(update?.file_extension)) {
      <video controls muted class="media-file">
        <source [src]="inBrowser ? getFileSrc(update?.file) : update?.file" />
        Your browser does not support the video tag.
      </video>
    } @else if ([".mp3"].includes(update?.file_extension)) {
      <audio
        [src]="inBrowser ? getFileSrc(update?.file) : update?.file"
        controls
        controlslist="play timeline volume nofullscreen nodownload noremoteplayback noplaybackrate"
      ></audio>
    } @else {
      <img
        (click)="onOpenImage($event, update)"
        [src]="inBrowser ? getFileSrc(update?.file) : update?.file"
        class="media-file"
      />
    }
  </div>
</ng-template>
